import SegmentedControl from '../../shared/SegmentedControl.vue';
import SegmentedTabs from './components/SegmentedTabs.vue';
import Vue from "vue";
import { Buffer } from "buffer";
import { installAndroidSafeArea } from './utils/android-safe-area';
if (typeof window !== "undefined") {
  window.Buffer = window.Buffer || Buffer;
}

import App from "./App.vue";
import router from "./router";
import store from "./store";
import i18n from "@/i18n"
import '@/assets/css/common.scss'

import Vant from 'vant'
import 'vant/lib/index.css'
Vue.use(Vant);

import IconFont from "@/components/iconFont.vue";
import IsLoadingList from "@/components/isLoadingList.vue";
import LanguageSettings from "@/components/languageSettings.vue";
Vue.component('IconFont', IconFont);
Vue.component('IsLoadingList', IsLoadingList);
Vue.component('LanguageSettings', LanguageSettings);

import StorageHandler from "@/utils/storageHandler";
import Common from "@/utils/common";
import filter from '@/utils/filter'
import Decimal from "decimal.js";
Vue.prototype.$StorageHandler = StorageHandler;
Vue.prototype.$Common = Common;
Vue.prototype.$Decimal = Decimal;

Vue.component('SegmentedControl', SegmentedControl);
Vue.component('SegmentedTabs', SegmentedTabs);
Vue.config.productionTip = false;
document.documentElement.style.fontSize = '16px';
installAndroidSafeArea();

// 全局错误捕获，防止未处理异常导致 App 崩溃
Vue.config.errorHandler = (err, vm, info) => {
  console.error('Vue error:', err, info);
};
window.addEventListener('unhandledrejection', (e) => {
  e.preventDefault();
  console.error('Unhandled rejection:', e.reason);
});
window.onerror = (msg, url, line, col, err) => {
  console.error('Global error:', msg, url, line);
  return true;
};

Vue.config.devtools = true
new Vue({
  router,
  store,
  i18n,
  created() {
    // Desktop browsers → PC site; mobile (incl. iPad) stays on H5.
    const isDesktop =
      navigator.userAgent.includes('Windows') ||
      (navigator.userAgent.includes('Macintosh') && navigator.maxTouchPoints < 2);
    if (process.env.VUE_APP_BUILD_TARGET === 'h5-prod' && isDesktop) {
      const pcBase = 'https://cointrendglobal.com';
      const params = window.location.search;
      if (params) {
        window.location.replace(`${pcBase}/#/market${params}`);
      } else {
        window.location.replace(`${pcBase}/`);
      }
    }
  },
  mounted() {
    window.addEventListener('resize', () => document.documentElement.style.fontSize = '16px');

    // 禁止用户双指放大
    // document.addEventListener('touchstart', function(event){
    //   if(event.touches.length > 1){
    //     event.preventDefault();
    //   }
    // }, { passive: false });
    // 禁止用户双击放大
    // var lastTouchEnd = 0;
    // document.addEventListener('touchend', function(event){
    //   var now = (new Date()).getTime();
    //   if(now - lastTouchEnd <= 300){
    //     event.preventDefault();
    //   }
    //   lastTouchEnd = now;
    // }, false);
  },
  render: (h) => h(App),
}).$mount("#app");
import "./ui-theme.css";
